import Service from '@/service/index.js';
import CollectivePurchasingService from '../../collective-purchasing-service';
import { mapGetters } from 'vuex';
import QRCode from 'qrcodejs2';
import { isPurchaseTypeFlag, getUnitByGoodsType } from '@/utils/common.js';

// import { errorMessage } from '@/utils/message.js';
export default {
  components: {
  },
  props: {
    projectInfo: {
      type: Object,
      default: {}
    },
    status: {
      type: String,
      default: {}
    }
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo'
    ]),
    noticeEndTimeHoursAdd1 () {
      const str = this.projectInfo && this.projectInfo.noticeEndTime;
      // 判断已成交的状态下
      if (this.projectInfo.status >= 70 && this.projectInfo.status <= 90) {
        this.projectInfo.status = 70;
      } else if (this.projectInfo.status === 93 || this.projectInfo.status === 94 || this.projectInfo.status === 95) {
        this.projectInfo.status = 95;
      }
      if (str) {
        const timeStr = new String(str).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
        return this.formatDate(new Date(new Date(timeStr).getTime() + 3600000 * 16 + 8 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  data () {
    return {
      purchaseProjectType: [],
      qualificationReview: [],
      purchaseType: [],
      purchaseStatus: [],
      isShowsignUpBtn: false,
      qrcodeShow: false
    };
  },
  filter: {
  },
  created () {
    this.id = this.$route.query.id;
    const obj = {
      PURCHASE_PROJECT_TYPE: 'purchaseProjectType',
      QUALIFICATION_REVIEW: 'qualificationReview',
      PURCHASE_TYPE: 'purchaseType',
      PURCHASE_SHOW_STATUS: 'purchaseStatus'
    };

    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        // console.log('getSelectList', res);
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  mounted () {
    this.creatQrCode();
  },
  watch: {
    projectInfo (newValue) {
      if (newValue) {
        if (this.isSignin) {
          this.checkCurrentUserSign();
        } else {
          this.checkCurrentUserSignForUnlogin();
          // this.isShowsignUpBtn = true;
        }
        if (Number(newValue.signStatus) === 0) {
          // 70 已成交的状态
          if (70 <= newValue.status && newValue.status <= 90) {
            newValue.status = 70;
          } else if (newValue.status === 92 || newValue.status === 93 || newValue.status === 94 || newValue.status === 95) {
            newValue.status = 95; // 95 已结束的状态
          }
        } else {
          newValue.status = 50; // 50 报名中
        }
      }
    }
  },
  methods: {
    isPurchaseTypeFlag,
    getUnitByGoodsType,
    // 划过二维码展示
    hover () {
      this.qrcodeShow = true;
    },
    hoverdown () {
      this.qrcodeShow = false;
    },
    // 生成二维码
    creatQrCode () {
      const url = window.location.host;
      let urlCode = '';
      if (url.indexOf('stage.portal-tiandong.cacfintech.com') >= 0 || url.indexOf('stage') >= 0) {
        urlCode = 'http://m.jlncjy.cn/#/purchaseProject/detail?purchaseId=' + this.$route.query.id;
      } else if (url.indexOf('test') >= 0) {
        urlCode = 'http://test.m.jlncjy.cacfintech.com/#/purchaseProject/detail?purchaseId=' + this.$route.query.id;
      } else if (url.indexOf('dev') >= 0 || url.indexOf('localhost') >= 0) {
        urlCode = 'http://dev.m.jlncjy.cacfintech.com/#/purchaseProject/detail?purchaseId=' + this.$route.query.id;
      } else {
        urlCode = 'http://m.jlncjy.com/#/purchaseProject/detail?purchaseId=' + this.$route.query.id;
      }
      new QRCode(this.$refs.qrCodeUrl, {
        text: urlCode, // 需要转换为二维码的内容
        width: 90,
        height: 90,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    popoverContent (code) {
      if (!code) { return; }
      return this.qualificationReview.find(item => item.code === String(code)) && this.qualificationReview.find(item => String(item.code) === String(code)).description;
    },
    getProjectStatusStyle (statued) {
      let status = Number(statued);
      if (status === 43) {
        return 'background: #F7B500';
      } else if (status === 50) {
        return 'background: #00B58D';
      } else if (status === 51) {
        return 'background: #0DCE03';
      } else if (status === 60) {
        return 'background: #FA5741';
      } else if ([70, 95, 96, 97].includes(status)) {
        return 'background: #383838';
      } else if (status === 42) {
        return 'background: #F7B500';
      }
    },
    onSignUp () {
      // 已登录状态
      if (this.isSignin) {
        // 村集体不能报名项目
        if (this.userInfo.type === 3) {
          this.$errorMessage('抱歉，农村集体经济组织用户不可参与项目报名。');
          return;
        }
        this.$emit('onSignUp');
      } else {
        this.$router.push('/signin');
      }
    },
    checkCurrentUserSignForUnlogin () {
      CollectivePurchasingService.checkCurrentUserSignForUnlogin(this.$route.query.id).then(res => {
        if (res && res.code === '0') {
          if (res.data) {
            this.isShowsignUpBtn = false;
            return;
          }
          this.isShowsignUpBtn = true;
        }
      });
    },
    checkCurrentUserSign () {
      CollectivePurchasingService.checkCurrentUserSign(this.id).then(res => {
        if (res && res.code === '0') {
          if (res.data) {
            this.isShowsignUpBtn = false;
            return;
          }
          this.isShowsignUpBtn = true;
        }
      });
    },
    formatDate (date, fmt) {
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      return fmt;
    }
  }
};
